module.exports = __webpack_public_path__ + "img/bg_slide_1.42cee682.png";